import InputPositionEditor from './InputPositionEditor'

export default InputPositionEditor
